/**
 * This class utilized by Modals.Loading service.
 */
import ModalSafe from "./safe.model";

export default class ModalLoading extends ModalSafe {
    
}